import PropTypes from "prop-types";
import React, { useState } from "react";
import { Row, Col, Alert, Card, CardBody, CardTitle, Container, FormFeedback, Input, Label, Form, Button } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import Breadcrumbs from "../../components/Common/Breadcrumb";


// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../store/actions";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo.svg";
import UserService from "Api/Services/UserService";
import Spinners from "components/Common/Spinner";

const Changepassword = props => {

    //meta title
    document.title = "Change Password | infuseone - Admin";
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [currentpwdError, setCurrentpwdError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [currenthideshowPassword, setCurrenthideshowPassword] = useState(false);
    const [newhideshowPassword, setNewhideshowPassword] = useState(false);
    const [confirmhideshowPassword, setconfirmhideshowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        const userData = {
            current_password: e.target.current_password.value,
            new_password: e.target.newPassword.value,
            confirm_password: e.target.confirmPassword.value
        };
        try {
            const response = await UserService.UserchangePassword(userData).json();
            if (response.status === true) {
                setError('');
                setCurrentpwdError('');
                setSuccess(response.message);
                setLoading(false);

            } else {
                setSuccess('');
                setLoading(false);
                setError(response.errors);
                setCurrentpwdError(response.message);
                return;
            }
        } catch (error) {
            setError('something went wrong');
            return;
        }
    };
    const previewcurrentPassword = () => {
        // setCurrentPassword(!currentPassword);
        setCurrenthideshowPassword(!currenthideshowPassword)

    };
    const previewnewPassword = () => {
        setNewhideshowPassword(!newhideshowPassword)
    };
    const previewconfirmPassword = () => {
        setconfirmhideshowPassword(!confirmhideshowPassword)
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Change password" />
                    <Row>
                        {isLoading ? <Spinners setLoading={setLoading} /> :
                            <Col xl={6}>
                                <Card className="commonboxform">
                                    <CardBody>
                                        {/* <CardTitle className="mb-4">Change password</CardTitle> */}
                                        {success && success.trim() !== "" ? (
                                            <Alert color="success" style={{ marginTop: "13px" }}>
                                                {success}
                                            </Alert>
                                        ) : (
                                            !error?.current_password && currentpwdError && (
                                                <Alert color="danger" style={{ marginTop: "13px" }}>
                                                    {currentpwdError}
                                                </Alert>
                                            )
                                        )}
                                        <Form onSubmit={handleSubmit}
                                            className="form-horizontal"
                                        >
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-firstname-Input">Current Password <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                <div className="d-flex gap-2">
                                                    <Input
                                                        type={currenthideshowPassword ? 'text' : 'password'}
                                                        name="current_password"
                                                        className="form-control"
                                                        placeholder="Enter Current Password"
                                                        // value={currentPassword}
                                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                                    />
                                                    <Button type="button" color="secondary" onClick={previewcurrentPassword} title={currenthideshowPassword ? 'Hide' : 'Show'} >
                                                        <i className={currenthideshowPassword ? 'bx bx-show' : 'bx bx-hide'}></i>
                                                    </Button>
                                                </div>
                                                {error?.current_password && (
                                                    <FormFeedback type="invalid" style={{ display: 'block' }}>{error.current_password[0]}</FormFeedback>
                                                )}

                                            </div>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-firstname-Input">New Password <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                <div className="d-flex gap-2">
                                                    <Input
                                                        type={newhideshowPassword ? 'text' : 'password'}
                                                        name="newPassword"
                                                        id="newPassword"
                                                        className="form-control"
                                                        placeholder="Enter New Password"
                                                        // value={newPassword}
                                                        onChange={(e) => setNewPassword(e.target.value)}

                                                    />
                                                    <Button type="button" color="secondary" onClick={previewnewPassword} title={newhideshowPassword ? 'Hide' : 'Show'} >
                                                        <i className={newhideshowPassword ? 'bx bx-show' : 'bx bx-hide'}></i>
                                                    </Button>

                                                </div>
                                                {error?.new_password && (
                                                    <FormFeedback type="invalid" style={{ display: 'block' }}>{error.new_password[0]}</FormFeedback>
                                                )}

                                            </div>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-firstname-Input">Confirm Password <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                <div className="d-flex gap-2">
                                                    <Input
                                                        type={confirmhideshowPassword ? 'text' : 'password'}
                                                        name="confirmPassword"
                                                        id="confirmPassword"
                                                        className="form-control"
                                                        placeholder="Enter Confirm Password"
                                                        // value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                    />
                                                    <Button type="button" color="secondary" onClick={previewconfirmPassword} title={confirmhideshowPassword ? 'Hide' : 'Show'} >
                                                        <i className={confirmhideshowPassword ? 'bx bx-show' : 'bx bx-hide'}></i>
                                                    </Button>
                                                </div>
                                                {error?.confirm_password && (
                                                    <FormFeedback type="invalid" style={{ display: 'block' }}>{error.confirm_password[0]}</FormFeedback>
                                                )}
                                            </div>


                                            <div>
                                                <button type="submit" className="btn btn-secondary w-md">
                                                    Change Password
                                                </button>
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        }
                    </Row>
                </Container>
            </div>
        </React.Fragment >
    );
};

Changepassword.propTypes = {
    history: PropTypes.object,
};

export default withRouter(Changepassword);
